import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { deleteRequest } from "../../../axios/Eventlog/EventLogApi";
import ConfirmActionDialog from "../../../components/ConfirmActionDialog";

const RemoveRequestDialog = ({
  onClose,
  onRefresh,
  info,
  isSwap = false,
}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleCloseDialog = () => {
    if (loading) return;
    onClose();
  };

  const handleRemoveRequest = async () => {
    const requestId = isSwap ? info.requestId : info.id;

    setLoading(true);
    try {
      const payload = {
        requestId,
        langId: localStorage.getItem("i18nextLngId"),
      };

      const response = await deleteRequest(payload);
      if (
        response.data.message === "Successful" ||
        response.data.message === "Thành công"
      ) {
        toast.success(t("common.remove-successfully"));
        handleCloseDialog();
        onRefresh?.();
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status !== 401) {
          toast.error(t(error?.response.data));
        }
      } else {
        toast.error(t("common.network-timeout"));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfirmActionDialog
      open
      variant="delete"
      title={t("common.confirm-remove-request")}
      subtitle={t("common.content-173")}
      confirmText={t("button.delete")}
      loading={loading}
      onClose={handleCloseDialog}
      onConfirm={handleRemoveRequest}
    />
  );
};

export default RemoveRequestDialog;
